import Model from './Model';

export default class Driver extends Model {
  resource() {
    return 'drivers';
  }
}
